import React, { ChangeEvent, Component } from "react";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IOnProcessVendorSourceDTO from "../../../models/DTO/IOnProcessVendorSourceDTO";
import IProcessVendorSourceDTO from "../../../models/DTO/IProcessVendorSourceDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import INewVendor_Source from "../../../models/INewVendor_Source";
import INotification from "../../../models/INotification";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUser";
import IVendor_Source from "../../../models/IVendor_Source";
import LeadTimeTypeEnum from "../../../models/LeadTimeTypeEnum";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import AddressBlock from "../../shared/AddressBlock/AddressBlock";
import OwButton from "../../shared/OwButton/OwButton";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwSelectOption from "../../shared/OwSelectOption/OwSelectOption";
import OwTitle from "../../shared/OwTitle/OwTitle";
import "./VendorSourceSidebar.scss";
import { Socket } from "socket.io-client";

type Props = {
    cancelFn: (refresh?: boolean) => void;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    socket: Socket;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    vendorSource?: IVendor_Source;
};

type State = {
    vendorSource: IVendor_Source | INewVendor_Source;
    isSaveActive: boolean;
};

class VendorSourceSidebar extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            vendorSource: this.props.vendorSource || ({ Bill_To: {}, Ship_To: {} } as INewVendor_Source),
            isSaveActive: false,
        };
    }

    componentDidMount() {
        this.props.socket.on(EndpointsEnum.PurchaseOrderOnProcessVendorSource, this.onProcessVendorSource);
    }

    componentWillUnmount() {
        this.props.socket.removeListener(EndpointsEnum.PurchaseOrderOnProcessVendorSource, this.onProcessVendorSource);
    }

    onProcessVendorSource = (data: IOnProcessVendorSourceDTO) => {
        const notification: INotification = {
            message: "successfully_processed_vendor_source",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.props.cancelFn(true);
    };

    cancel = () => {
        this.props.cancelFn(false);
    };

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const vendorSource = this.state.vendorSource;

        // @ts-expect-error
        vendorSource[name] = value;

        this.setState({ vendorSource });
    };

    handleAddressChange = (e: ChangeEvent<any>, type: "Bill_To" | "Ship_To") => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const vendorSource = this.state.vendorSource;

        // @ts-expect-error
        vendorSource[type][name] = value;

        this.setState({
            vendorSource,
        });
    };

    save = () => {
        const payload: IProcessVendorSourceDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            vendorSource: {
                ...this.state.vendorSource,
            },
        };

        this.props.socket.emit(EndpointsEnum.PurchaseOrderProcessVendorSource, payload);

        this.setState({
            isSaveActive: true,
        });
    };

    copyBillToShipTo = () => {
        const vendorSource = this.state.vendorSource;

        vendorSource.Ship_To = {
            ...vendorSource.Bill_To,
        };

        this.setState({
            vendorSource,
        });
    };

    render() {
        const lead_time_options = [
            { value: LeadTimeTypeEnum.DAYS, title: "Day(s)" },
            { value: LeadTimeTypeEnum.WEEKS, title: "Week(s)" },
            { value: LeadTimeTypeEnum.MONTHS, title: "Month(s)" },
        ];

        return (
            <div className="VendorSourceSidebar p-2">
                <div className={"row"}>
                    <div className={"col-12"}>
                        <div className="text-end">
                            <button className="btn btn-danger btn-sm" onClick={this.cancel}>
                                <i className="far fa-times" />
                            </button>
                        </div>
                        <OwTitle className={"mb-2"} leftIconName={"fad fa-handshake"} title={"vendor_source"} />
                        <hr />
                    </div>
                </div>

                <div>
                    <div>
                        <OwLabel title={"name"} />
                        <OwInputWrapper name={"name"} fn={this.handleChange} value={this.state.vendorSource.name} />
                    </div>

                    <div>
                        <OwLabel title={"customer_no"} />
                        <OwInputWrapper name={"customer_no"} fn={this.handleChange} value={this.state.vendorSource.customer_no} />
                    </div>

                    <div>
                        <OwLabel title={"email"} />
                        <OwInputWrapper name={"email"} fn={this.handleChange} value={this.state.vendorSource.email} type={"email"} />
                    </div>

                    <div>
                        <OwLabel title={"bill_to"} />
                        <AddressBlock
                            showCompanyName={true}
                            showName={true}
                            address={this.state.vendorSource.Bill_To}
                            fn={(e: any) => {
                                this.handleAddressChange(e, "Bill_To");
                            }}
                        />
                    </div>

                    <div>
                        <div className={"d-flex align-items-center mb-2"}>
                            <OwLabel title={"ship_to"} />{" "}
                            <div className={"ms-2"}>
                                <OwButton title={"copy_bill_to_ship_to"} fn={this.copyBillToShipTo} />
                            </div>
                        </div>
                        <AddressBlock
                            showCompanyName={true}
                            showName={true}
                            address={this.state.vendorSource.Ship_To}
                            fn={(e: any) => {
                                this.handleAddressChange(e, "Ship_To");
                            }}
                        />
                    </div>
                </div>

                <div className={"mt-2"}>
                    <OwLabel title={"lead_time"} />
                    <div className={"d-flex"}>
                        <div className={"w-30"}>
                            <OwInputWrapper
                                title={"default_lead_time"}
                                name={"default_lead_time"}
                                fn={this.handleChange}
                                value={this.state.vendorSource.default_lead_time}
                            />
                        </div>
                        <div className={"ms-2"}>
                            <OwSelectOption
                                selectedOption={this.state.vendorSource}
                                selectedOptionProp={"default_lead_time_type"}
                                options={lead_time_options}
                                valueProp={"value"}
                                titleProp={"title"}
                                fn={this.handleChange}
                                name={"default_lead_time_type"}
                                showBlankFirst={true}
                            />
                        </div>
                    </div>
                </div>

                <div>
                    <OwButton title={"save"} fn={this.save} active={this.state.isSaveActive} disableOnActive={true} />
                </div>
            </div>
        );
    }
}

export default VendorSourceSidebar;
